import { useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';

export function useQuery() {
  const [_params, _setParams] = useSearchParams();

  const params = useMemo(() => {
    const p = {};

    for (const [key, value] of _params.entries()) {
      p[key] = value;
    }
    return p;
  }, [_params]);

  const setParams = useMemo(
    () =>
      (newParams, { replace = true } = {}) => {
        _setParams(newParams, { replace });
      },
    [_setParams]
  );

  return [params, setParams];
}
